<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">菜单管理</div>
          <span class="m-title-s">对系统内菜单导航进行新增、编辑、排序等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>系统菜单列表
          </div>
          <div class="m-table-btn">
            <el-button @click="addMenu" type="primary">新增菜单</el-button>
          </div>
        </el-container>
        <el-table :data="menuList" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;"
                  row-key="id" border :tree-props="{children: 'children'}" size="mini">
          <el-table-column prop="title" label="菜单名称" width="220"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="60"></el-table-column>
          <el-table-column prop="sort" label="排序" align="center" width="60"></el-table-column>
          <el-table-column prop="href" label="路径"></el-table-column>
          <el-table-column prop="power" label="权限"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="menuForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="menuDel(scope.row.id, scope.row.title)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="上级菜单: " prop="parentName">
              <el-input v-model="form.parentName" :id="form.parentId" placeholder="点击右侧按钮" disabled>
                <el-button type="primary" slot="append"  @click="tree = true">选择上级菜单</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="菜单名称: " prop="title">
              <el-input v-model="form.title" placeholder="输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="目标链接: " prop="href">
              <el-input v-model="form.href" placeholder="输入目标链接"></el-input>
            </el-form-item>
            <el-form-item label="权限标识: " prop="power">
              <el-input v-model="form.power"  placeholder="输入权限标识"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort"  placeholder="输入排序"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
      <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" center append-to-body>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree class="filter-tree" :data="menuList" :props="defaultProps" node-key="id" default-expand-all :filter-node-method="filterNode">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
        </el-tree>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MenuManage',
  data () {
    return {
      openText: '新增菜单',
      openState: false,
      tree: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      filterText: '',
      menuList: [],
      form: {
        id: '',
        parentName: '',
        parentId: '',
        title: '',
        href: '',
        sort: '',
        status: '1',
        power: '',
        remarks: ''
      },
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      rules: {
        title: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        href: [
          { required: true, message: '请输入目标链接址', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        power: [
          { required: true, message: '请输入权限标识', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请填写备注说明', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog: function () {
      this.form = {
        id: '',
        parentId: '',
        title: '',
        href: '',
        sort: '',
        status: '1',
        power: '',
        remarks: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    selectMenu (e) {
      if (this.form.id === e.target.parentElement.value) {
        this.$message.error('选项自身不可做父级')
        return
      }
      this.tree = false
      this.form.parentName = e.target.parentElement.name
      this.form.parentId = e.target.parentElement.value
    },
    addMenu () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          if (_this.form.parentId === '') {
            _this.$message.error('请选择所属菜单！')
            _this.formLoading = false
            return
          }
          _this.form.status = _this.isStatus === true ? '1' : '0'
          this.$axios.post('/sys/menu/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.menuData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    menuDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/sys/menu/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.menuData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    menuForm (form) {
      let _this = this
      // 顶级栏目不可编辑
      if (form.parentId === '0') {
        _this.$message.error('此菜单不可编辑！')
        return
      }
      _this.form = form
      // 判断开启状态，1：开启，0:关闭
      _this.isStatus = _this.form.status === '1'
      // 渲染父级菜单标题
      for (let i = 0; i < _this.menuList.length; i++) {
        if (_this.menuList[i].id === _this.form.parentId) {
          this.form.parentName = _this.menuList[i].title
          // console.log('1')
          break
        }
        for (let j = 0; j < _this.menuList[i].children.length; j++) {
          if (_this.menuList[i].children[j].id === _this.form.parentId) {
            this.form.parentName = _this.menuList[i].children[j].title
            // console.log('2')
            break
          }
        }
      }
      this.openText = '编辑'
      _this.openState = true
    },
    // 菜单列表
    menuData () {
      let _this = this
      this.isLoading = true
      _this.menuList = []
      this.$axios.post('/sys/menu/list')
        .then((res) => {
          _this.menuList = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.menuData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/Menu.vue